import React, { Component } from "react";
import PropTypes from "prop-types";
import { withStyles } from "material-ui/styles";
import AccountListItem from "./AccountListItem";
import List from "material-ui/List";
import CenteredProgress from "./CenteredProgress";

const styles = theme => ({
  root: {
    flexGrow: 1,
    background: theme.palette.background.paper,
    overflow: "auto",
    height: "100%",
    position: "relative"
  },
  fabSpacer: {
    height: 60
  }
});

class AccountsIndex extends Component {

  renderAccounts() {
    const { accounts } = this.props;

    return accounts.map((account, i) => {
      return <AccountListItem key={i} account={account} />;
    });
  }

  render() {
    const { classes, loading } = this.props;

    if (loading) {
      return <CenteredProgress />;
    }

    return (
      <div className={classes.root}>
        <List>{this.renderAccounts()}</List>
        <div className={classes.fabSpacer} />
      </div>
    );
  }
}

AccountsIndex.propTypes = {
  accounts: PropTypes.array.isRequired,
  fetchAccounts: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  sortBy: PropTypes.string.isRequired
};

export { AccountsIndex };

export default withStyles(styles, { name: "AccountsIndex" })(AccountsIndex);



// WEBPACK FOOTER //
// ./src/AccountsIndex.js